// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_page__Ge592 {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 74px;
    margin: 35px auto 58px;
    width: var(--container-width);
    max-width: 100%;
    padding: 0 var(--container-padding);
}

.storage_content__2sXdq {
    flex: 1 1;
}

.storage_items__UR3BV {
    display: flex;
    flex-wrap: wrap;
    grid-gap: var(--folder-gap);
    justify-content: flex-start;
}

.storage_items__UR3BV.storage_open__aYV1i {
    grid-gap: var(--folder-item-gap);
}

.storage_previewItem__BOuhN {
    width: 182px;
}

.storage_item__F31YG {
    display: flex;
    flex-direction: column;
    --width: 226px;
}
.storage_imgWrapper__smjkd {
    border: 1px solid #7b848e;
    width: 226px;
    height: 186px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.storage_imgWrapper__smjkd img {
    width: 130px;
}

.storage_link__0oC0a {
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-gap: 40px;
    margin-top: 30px;
}

.storage_title__wPJGk {
    /*min-height: 46px;*/
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .storage_item__F31YG {
        --width: 180px;
    }

    .storage_imgWrapper__smjkd {
        width: 180px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/Storage/storage.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["@value screen-md-max from '../../../breakpoints.css';\n\n.page {\n    display: flex;\n    flex-wrap: wrap;\n    grid-gap: 74px;\n    margin: 35px auto 58px;\n    width: var(--container-width);\n    max-width: 100%;\n    padding: 0 var(--container-padding);\n}\n\n.content {\n    flex: 1;\n}\n\n.items {\n    display: flex;\n    flex-wrap: wrap;\n    grid-gap: var(--folder-gap);\n    justify-content: flex-start;\n}\n\n.items.open {\n    grid-gap: var(--folder-item-gap);\n}\n\n.previewItem {\n    width: 182px;\n}\n\n.item {\n    display: flex;\n    flex-direction: column;\n    --width: 226px;\n}\n.imgWrapper {\n    border: 1px solid #7b848e;\n    width: 226px;\n    height: 186px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.imgWrapper img {\n    width: 130px;\n}\n\n.link {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    grid-gap: 40px;\n    margin-top: 30px;\n}\n\n.title {\n    /*min-height: 46px;*/\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@media screen-md-max {\n    .item {\n        --width: 180px;\n    }\n\n    .imgWrapper {\n        width: 180px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"page": `storage_page__Ge592`,
	"content": `storage_content__2sXdq`,
	"items": `storage_items__UR3BV`,
	"open": `storage_open__aYV1i`,
	"previewItem": `storage_previewItem__BOuhN`,
	"item": `storage_item__F31YG`,
	"imgWrapper": `storage_imgWrapper__smjkd`,
	"link": `storage_link__0oC0a`,
	"title": `storage_title__wPJGk`
};
export default ___CSS_LOADER_EXPORT___;
